'use strict';

//
import './view.less';

//
import React from 'react';
import classnames from 'classnames'

//
import Component from '../core/component';
import Enhance from '../core/enhance';

const cache = {};


class View extends Component {
    state = {};

    constructor(props) {
        super(props);
    }

    /**
     * 输入参数 nextProps 是即将被设置的属性，
     * 旧的属性还是可以通过 this.props 来获取。
     * 在这个回调函数里面，你可以根据属性的变化，
     * 通过调用 this.setState() 来更新你的组件状态，这里调用更新状态是安全的，
     * 并不会触发额外的 render() 调用
     */
    componentWillReceiveProps(nextProps) {
        if (this.props.children !== nextProps.children) {
            this.renderContent((nextProps.children || ''));
        }
    }

    /**
     * componentDidMount()在挂载结束之后马上被调用。需要DOM节点的初始化操作应该放在这里。
     */
    componentDidMount() {
        this.renderContent((this.props.children || ''));
    }

    renderContent(content) {
        content = content.toString().replace(/<img\s+[^>]+>/gi, function (a, b, c) {
            return a.replace('src', 'data-src');
        });


        $(this.refs.html).html(content);
        $('[data-src]', this.refs.html).each((k, img) => {
            let {width, height} = $(img).data();
            if (width && height) {
                let canvas = $(`<canvas width="${width}" height="${height}" style="display:none;"></canvas>`)[0];
                var dataURL = canvas.toDataURL("image/png");
                img.src = dataURL;

            }

        })
        this.handlerLazyLoad();
    }

    /**
     *
     * @returns {*}
     */
    render() {
        return (
            <div className={classnames('c-view view')} ref="html"/>
        );
    }

    /**
     *
     * @private
     */
    handlerLazyLoad = () => {
        this.state.timer = setInterval(this.handlerScroll, 500);
    }

    /**
     *
     * @private
     */
    handlerScroll = () => {
        const images = $(this.refs.html).find('img[data-src]');
        if (images.length > 0) {
            images.each((i, img) => {
                let rect = img.getBoundingClientRect();//返回某个元素在视窗中的位置，包括left、right、top、bottom、width、height
                let $img = $(img);
                if ((rect.top >= 0 && rect.top < window.innerHeight) && (rect.left >= 0 && rect.left < window.innerWidth)) {
                    let src = $img.attr('data-src');
                    if (cache[src]) {
                        this.handlerLoad(img, src);
                    } else {
                        $img.removeAttr('data-src');
                        let image = new window.Image;
                        image.onerror = () => {
                            this.handlerError
                        };
                        image.onload = (e) => {
                            this.handlerLoad(img, src);
                        };
                        image.src = src;
                    }
                }
            })
        } else {
            clearInterval(this.state.timer)
        }

    }

    /**
     *
     * @param img
     * @param src
     * @private
     */
    handlerLoad = (img, src) => {
        cache[src] = true;
        $(img).attr('src', src).addClass('animated fadeIn');//.removeClass('loading');
    }

    /**
     *
     * @private
     */
    handlerError = () => {

    }
}

Enhance(View, {}, 'View');

export default View;
